<template>
<div>
 
  
  <div class="table-responsive-sm mt-1">
  <table class="table table-bordered table-sm my-table">
     <caption>Tabella prezzo per misura</caption>

    <thead class="thead-light sticky-col">

      <tr>
        <th class="text-center">PREZZO</th>        
        <th v-for="(col, index) in cols"
            :key="'size-'+ index"
            class="text-center sticky-col"
            >
          {{ col.size }}
        </th>
      </tr>

    </thead>

    <tbody>

      <tr v-for="(row, rIndex) in rows" :key="rIndex">
        <!-- TIPO -->
        <td class="text-nowrap">
          {{ row.tipo }}
        </td>
                        
        <!-- CAMPI PER MISURA -->
        <td v-for="(col, cIndex) in cols" :key="cIndex">
          <input required type="number" min="0.1" step="0.01"
                 class="form-control form-control-sm inputClass sticky-col"
                 v-model="row.prezzi[col.sizeId]"
                 >
        </td>        
      </tr>

    </tbody>
  </table>




 </div>
 

    
  <div v-if="false">
      <h5 class="mb-4">Dati JSON TABLE:</h5>
      <pre>{{ sizes }} {{ labels }} </pre> 
      
  </div>


</div> 
</template>

<script>

import { mapGetters }       from 'vuex';


export default {
  
  components: {},  
  props: ['sizes','costPrice','retailPrice','items','refresh'],
  
  data () {
  
    return {
    
     cols          : [],
     rows          : [],
     table         : false 
     
     

    
   

    }
  },
 
  computed:
  {
    ...mapGetters(['company']),
  },
  
  watch: {
    refresh()
    { 
       //this.refreshLabels++     
       this.$nextTick(() => {
        this.$emit('update',this.rows)
       })
      
    },
    costPrice(newValue) {
      
      this.setCostPrice(newValue)
    },
    retailPrice(newValue) {
      
      this.setRetailPrice(newValue)
    }
  },

   directives: 
    {
      

    },
  mounted()
    {
      
    },
  created()
  {
  
   if(this.items.prices)
   {
      //console.log('DATA1',this.items.prices)
      this.createItemsFromBackend(this.items) 
   }
   else
   {
      //console.log('DATA2',this.items.prices)
      this.createItems() 
   }
   

  },

  methods: 
  { 

      /*
      setPrices(prices)
      {
        // console.log('PREZZI',prices)
      },
      */

      setCostPrice(value) {
          // Per ogni colonna dinamica (escludendo la prima)
          this.cols.forEach(col => {
          // Imposta il valore della cella
          this.rows[0].prezzi[col.sizeId] = value;
          this.setData()
          
      })
      },
      setRetailPrice(value) {
          // Per ogni colonna dinamica (escludendo la prima)
          this.cols.forEach(col => {
          // Imposta il valore della cella
          this.rows[1].prezzi[col.sizeId] = value;
          this.setData()
      })
      },

      

      setData()
      {
       
        this.$emit('update',this.rows)
      },
    

      createItemsFromBackend(data) {
              
              // console.log('PREZZO PER MISURA1',this.sizes)
             
             
             
              /* DEVO USARE TUTTE LE MISURE CHE PASSO NEL MAPPING */
            
              /*
              const sizes = this.sizes.map(p => ({
                size   : p.size,
                sizeId : p.sizeId
              }));
              */

              /*
              const sizes = data.prices.map(p => ({
                size   : p.size,
                sizeId : p.sizeId
              }));
              */

              this.cols = this.sizes; // colonne della tabella


              // Crea due oggetti prezzi con valori iniziali
              const prezziAcquisto = {};
              const prezziVendita  = {};
             
             
              this.sizes.forEach(s => {
                const priceObj = data.prices.find(p => Number(p.sizeId) === Number(s.sizeId));
      
                if (priceObj) 
                {
                  
                  // Vue 2: usa $set per garantire la reattività se aggiungi chiavi
                  this.$set(prezziAcquisto, s.sizeId, priceObj.costPrice || this.costPrice);
                  this.$set(prezziVendita, s.sizeId,  priceObj.retailPrice || this.retailPrice);


                } else {
                                   
                  this.$set(prezziAcquisto, s.sizeId,   this.costPrice);
                  this.$set(prezziVendita, s.sizeId, this.retailPrice);
                  
                }


              });


              // Righe della tabella
              this.rows = [
                { tipo: "ACQUISTO €", prezzi: prezziAcquisto },
                { tipo: "VENDITA €",  prezzi: prezziVendita }                
              ];

            

      },

    createItems()
      {
       

        const generaItems = (acquisto,vendita) => {                   
            return [
              { tipo: "ACQUISTO €", prezzi : { ...acquisto } },
              { tipo: "VENDITA €",  prezzi : { ...vendita } }
            ];
          
          }



        const  generaCols = (items) => {
           
            return [...new Map(
              items
              .sort((a, b) => a.colOrder - b.colOrder)
              .map(item => [item.sizeId, {
              sizeId   : item.sizeId,
              size     : item.size,
              colOrder : item.colOrder
              }])
              ).values()]
            }   




        /* 
        const generaCols = (misure) => {
        return misure.map((m) => {
          return {
            size    : m.size,
            sizeId  : m.sizeId
          };
        });
        };

*/

          // NUOVO PRODOTTO PASSO ARRAY ALTRIMENTI 
          const sizes = this.sizes
          
          const prezzi = Object.fromEntries(

              sizes.map(m => [m.sizeId, 0])
            );
          
          //const prezzi = createPrezzi(sizes)
         this.cols      = generaCols(sizes)
         //this.cols    = this.sizes

         this.rows    = generaItems(prezzi,prezzi)
        
         //console.log(prezzi)

      },      
  }
  
}
</script>

<style scoped>


.table {
  border-collapse: separate;
}
.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 14px;
}
.pointer{
  cursor: pointer;
}
thead th.sticky-col {
  z-index: 20;
  background: #28a745;
  color: white;
  border-color: white !important;
  border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */

}

.my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}





</style>